import * as yup from 'yup'

export default yup.object().shape({
  collection: yup.object().nullable().required().label('Collection'),
  templateId: yup.string().max(500).required().label('Template')
})
